import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '../store'
import { OrderInterface } from '../../common/types/interfaces'

const initialState: { data: OrderInterface[] } = {
  data: [],
}

export const orderListSlice = createSlice({
  name: 'order-list',
  initialState,
  reducers: {
    setOrderList: (state, action: PayloadAction<OrderInterface[]>) => {
      state.data = [ ...action.payload ]
    },
  },
})

export const { setOrderList } = orderListSlice.actions

export const selectOrderList = (state: RootState) => state.orderList.data
export const selectOrderItem = (state: RootState, id: number) =>
  state.orderList.data.find((el) => el.id === id)

export default orderListSlice.reducer
